module.exports = __webpack_public_path__ + "img/cut2img.35c77589.png";